// Root API url
//export const API_URL = '/API'; //TODO
export const API_URL = '/api';
// Authorization
export const API_AUTHORIZATION_URL = `${API_URL}/token`;
